<ul class="breadcrumb">
   <li *ngFor="let item of hierarchyResult">
      <a [routerLink]="item.link">{{ item.name }}</a>
   </li>
</ul>
